// noinspection DuplicatedCode

import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API


export const getSpecClaimPengobatan = createAsyncThunk(
    "claimPengobatanTransaksi/getSpecClaimPengobatan",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSpecPengobatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getClaimPengobatanTransaksi = createAsyncThunk(
    "claimPengobatanTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getPengobatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertClaimPengobatanTransaksi = createAsyncThunk(
    "claimPengobatanTransaksi/insert",
    async ({
               Nik,
               JenisPengobatan,
               TanggalSakit,
               TanggalSelesai,
               NamaDokter,
               RumahSakit,
               JenisRawat,
               BiayaDokter,
               TotalBiayaObat,
               JenisObat,
               FileUUID
           }, thunkAPI) => {
        let formData = new FormData();
        let arr = [];
        arr.push(JenisObat);
        formData.append("Nik", Nik);
        formData.append("JenisPengobatan", JenisPengobatan);
        formData.append("TanggalSakit", TanggalSakit);
        formData.append("TanggalSelesai", TanggalSelesai);
        formData.append("NamaDokter", NamaDokter);
        formData.append("RumahSakit", RumahSakit);
        formData.append("JenisRawat", JenisRawat);
        formData.append("BiayaDokter", BiayaDokter);
        formData.append("TotalBiayaObat", TotalBiayaObat);
        formData.append("JenisObat", arr);
        formData.append("FileUUID", FileUUID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertPengobatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateClaimPengobatanTransaksi = createAsyncThunk(
    "claimPengobatanTransaksi/update",
    async ({
               TPengobatanID,
               Nik,
               JenisPengobatan,
               TanggalSakit,
               TanggalSelesai,
               NamaDokter,
               RumahSakit,
               JenisRawat,
               BiayaDokter,
               TotalBiayaObat,
               JenisObat,
               FileUUID
           }, thunkAPI) => {
        let formData = new FormData();
        let arr = [];
        arr.push(JenisObat);
        formData.append("TPengobatanID", TPengobatanID);
        formData.append("Nik", Nik);
        formData.append("JenisPengobatan", JenisPengobatan);
        formData.append("TanggalSakit", TanggalSakit);
        formData.append("TanggalSelesai", TanggalSelesai);
        formData.append("NamaDokter", NamaDokter);
        formData.append("RumahSakit", RumahSakit);
        formData.append("JenisRawat", JenisRawat);
        formData.append("BiayaDokter", BiayaDokter);
        formData.append("TotalBiayaObat", TotalBiayaObat);
        formData.append("JenisObat", arr);
        formData.append("FileUUID", FileUUID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updatePengobatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getClaimReport = createAsyncThunk(
    "getClaimReport/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/claim/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getClaimReportDetail = createAsyncThunk(
    "getClaimReportDetail/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/claim/lap/detail',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetClaimSlice = createAsyncThunk(
    "resetClaimSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
export const resetClaimDetailSlice = createAsyncThunk(
    "resetClaimDetailSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
//INIT
const initialState = {
    message: "",
    SpecClaimPengobatanData: [],
    isSpecClaimPengobatanFetching: false,
    isSpecClaimPengobatanSuccess: false,
    isSpecClaimPengobatanError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false,
    isGetReportDetail: false,
};


//SLICES
export const claimPengobatanTransaksiSlice = createSlice({
    name: "pengobatanTransaksi",
    initialState,
    reducers: {},
    extraReducers: {
        // GET
        [getClaimReport.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.isGetReport = true;
            state.message = payload.message;
            return state;
        },
        [getClaimReport.rejected]: (state, {payload}) => {
            state.isGetReport = false;
        },
        [getClaimReport.pending]: (state) => {
            state.isGetReport = false;
        },

        [getClaimReportDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.reportDetail = payload.data;
                state.message = payload.message;
            }
            state.isGetReportDetail = true;
            return state;
        },
        [getClaimReportDetail.rejected]: (state, {payload}) => {
            state.isGetReportDetail = false;
        },
        [getClaimReportDetail.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [resetClaimDetailSlice.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [getSpecClaimPengobatan.fulfilled]: (state, {payload}) => {
            state.SpecClaimPengobatanData = payload.data[0];
            state.isSpecClaimPengobatanSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecClaimPengobatan.rejected]: (state, {payload}) => {
            state.isSpecClaimPengobatanFetching = false;
        },
        [getSpecClaimPengobatan.pending]: (state) => {
            state.isSpecClaimPengobatanFetching = false;
        },

        [getClaimPengobatanTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getClaimPengobatanTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getClaimPengobatanTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertClaimPengobatanTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertClaimPengobatanTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertClaimPengobatanTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateClaimPengobatanTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateClaimPengobatanTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateClaimPengobatanTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const claimPengobatanTransaksiSelector = (state) => state.claimPengobatanTransaksi;
  